<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" sm="6" md="5" lg="4" offset-lg="1">
        <v-img src="@/assets/images/pre_calificador.png" contain />
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="5" offset-lg="1" order-xl="0" order-sm="1">
        <v-form ref="form">
          <v-row dense>
            <v-col cols="12" class="text-color-main text-center">
              <p class="text-h5 text-md-h4 text-lg-h3 pt-5 font-weight-bold">CREDITARIA DIVISION YUCATAN</p>
            </v-col>
            <v-col cols="12">
              <label class="text--black font-weight-medium text-uppercase">
                Esta vivienda va a pertenecer a:
              </label>
              <v-row dense>
                <v-col cols="6">
                  <v-text-field
                    v-model="credito.nombres"
                    placeholder="Nombre (s)"
                    :rules="fieldRequired"
                    outlined
                    dense/>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="credito.apellidos"
                    placeholder="Apellido (s)"
                    :rules="fieldRequired"
                    outlined
                    dense/>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12">
              <label class="text--black font-weight-medium text-uppercase">
                Ingresa tu email*
              </label>
              <v-text-field
                v-model="credito.email"
                placeholder="example@gmail.com"
                :rules="fieldRequired"
                outlined
                dense/>
            </v-col>

            <v-col cols="12">
              <label class="text--black font-weight-medium text-uppercase">
                Ingresa tu número telefonicó*
              </label>
              <v-text-field
                v-model="credito.phone"
                placeholder="9999234234"
                :rules="fieldRequired"
                outlined
                dense/>
            </v-col>

            <v-col cols="12">
              <label class="text--black font-weight-medium text-uppercase">
                Ingresa el costo de tu vivienda*
              </label>
              <v-text-field
                v-model.number="credito.precioVivienda"
                placeholder="Costo de la vivienda"
                :rules="fieldRequired"
                type="number"
                min="0"
                outlined
                dense/>
            </v-col>

            <v-col cols="12">
              <label class="text--black font-weight-medium text-uppercase">
                Ingresa el monto del crédito*
              </label>
              <v-text-field class="pa-0 ma-0"
                v-model.number="credito.creditoBanco"
                placeholder="Monto del Crédito"
                :rules="fieldRequired"
                @keydown="validateCaracter"
                type="number"
                min="0"
                outlined
                dense/>
                <span class="caption font-weight-bold text-color-main text-decoration-underline">
                  "El Max. de crédito es 90% independientes y 95% Asalariado, sobre el precio de la vivienda."
                </span>
            </v-col>
            <v-col cols="12">
              <div class="my-3">
              <v-checkbox v-model="terminos" color="#026270" hide-details @change="showAlertTerminosyCondiciones">
                <template v-slot:label>
                  <div>
                    Aceptar <span class="font-weight-bold text-color-main"> Términos y Condiciones</span>
                  </div>
                </template>
              </v-checkbox>
              </div>

              <v-btn color="#026270" class="title" @click="sendPrecalificador" block large dark>
                <v-icon large>mdi-home</v-icon>
                Simular Crédito
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
    <MainAlertDialog v-if="get_dialogAlertMain.dialog" :message="message"/>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import router from '@/router'
import { NumberUtils } from '@/mixins/NumberUtilsMixin'
import { Validate } from '@/mixins/validateFormMixin'
import MainAlertDialog from '@/components/dialogs/MainAlertDialog'
export default {
  name: 'PrecalificacionGral',
  mixins: [NumberUtils, Validate],
  data: () => ({
    credito: {},
    terminos: false,
    message: 'La presente simulacion es de caracter informativo y no representa bajo ninguna circustancia o causa la autorizacion de un credito.' +
    'El presente instrumento busca promover las ventajas y competencia de la obtencion de un credito hipotecario y no debe enterarse como un compromiso de' +
    'firma de credito o gestion de este, el simulador emite un resultado en base a los datos parametricos proporcionado por el solicitante y/o usuario de la herramienta: sin embargo,' +
    'el usuario no puede autenticar la informacion proporcionad, las condiciones de medicion del suimulador puede variar sin previo aviso.' +
    'Por lo que en caso de requerir uina cotizacion deberaq solicitarla a su ejecutivo de Creditaria para que el la tramite ante la institucion financiera. El presente simulador es propiedad Creditaria,' +
    'S.A de C.V 2023, con fines informativos, en caso de requerir mas informacion ponemos nuestro aviso de privacidad https://precacreditaria.com/',
    referencia: '',
    fullPath: ''
  }),
  mounted () {
    console.log('$route', this.$route)
    if (this.$route.params.referencia) {
      this.referencia = this.$route.params.referencia
      this.fullPath = this.$route.fullPath
    }
  },
  components: {
    MainAlertDialog
  },
  methods: {
    ...mapMutations(['SHOW_DIALOG_ALERT_MAIN']),
    sendPrecalificador () {
      if (this.$refs.form.validate()) {
        this.credito.fullPath = this.fullPath
        this.credito.referencia = this.referencia
        this.$cookies.set('credito_gral', this.credito)
        router.push({ name: 'PrecalificadorGralView' })
      }
    },
    showAlertTerminosyCondiciones () {
      if (this.terminos) {
        this.main = {}
        this.form = this.get_CorreosdForm
        this.SHOW_DIALOG_ALERT_MAIN({ type: 'view', with: 450, title: 'Términos y Condiciones' })
      }
    },
    MostrarColumna (indicador, pantalla) {
      const tam = this.$vuetify.breakpoint.name
      console.log(tam)
      if (indicador === '!=') return (tam !== pantalla)
    },
    validateCaracter (e) {
      // Si el código es menor que 48 (0) o mayor que 57 (9)
      if (e.keyCode < 48 || e.keyCode > 57) {
        if (e.keyCode !== 8) e.preventDefault()
      }
    }
  },
  computed: {
    ...mapGetters(['get_dialogAlertMain'])
  }
}
</script>

<style scoped>
.text-color-main{
  color: #026270;
}
</style>
